export default __webpack_public_path__ + "static/media/MainBg.8f6f3e6e.jpg";